<template>
  <svg class="w-5 h-5" viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 12H12.0001C12.7365 12 13.3334 11.403 13.3334 10.6667V3.33333C13.3334 2.59695 12.7365 2 12.0001 2H6.00008C5.2637 2 4.66675 2.59695 4.66675 3.33333V4.66667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2396 6.31344L9.01981 5.09364C8.74632 4.82015 8.37539 4.6665 7.98861 4.6665H4.00008C3.2637 4.6665 2.66675 5.26346 2.66675 5.99984V12.6665C2.66675 13.4029 3.2637 13.9998 4.00008 13.9998H9.33341C10.0698 13.9998 10.6667 13.4029 10.6667 12.6665V7.34464C10.6667 6.95786 10.5131 6.58693 10.2396 6.31344Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 7.6665H8.66675C8.11446 7.6665 7.66675 7.21879 7.66675 6.6665V4.6665"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts" />